import React from 'react';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { getLocalizedName } from '../../localization/LocalizedString';
import { Link } from "react-router-dom";

class InstallationDocumentModalItem extends React.Component {
  render() {
    const {
      id,
      updatedAt,
      status,
      customer,
      devices,
      translate,
      destinationId,
      businessCustomer,
      currenLanguage,
    } = this.props;
    const {
      city,
      postalCode,
    } = customer;

    const renderDeviceNames = devices.map((obj) => {
      return (
        <p>{getLocalizedName(obj, currenLanguage)}</p>
      );
    });

    const renderShipmentId = devices.map((obj) => {
      return (
        <p>{obj.shipmentId}</p>
      );
    });

    let to = {};
    let page = "";
    const installationCode = devices[0].shipmentId;
    const linkURL = `/installationDocument/${devices[0].shipmentId}/${id}`;

    const installationShipmentStatus = status.value.endsWith("_COMPLETED") ? translate("work_list.status.WEB_TO_WEB_COMPLETED") :
        status.value.endsWith("_ORDERED") ? translate("work_list.status.WEB_TO_WEB_ORDERED") :
            status.value.endsWith("_TIME_AGREED") ? translate("work_list.status.WEB_TO_WEB_TIME_AGREED") :
                status.value.endsWith("_UNCOMPLETED") ? translate("work_list.status.WEB_TO_WEB_UNCOMPLETED") :
                    status.value.endsWith("_CANCELLED") ? translate("work_list.status.WEB_TO_WEB_CANCELLED") :
                        translate("work_list.status.WEB_TO_WEB_CUSTOMER_UNREACHABLE");

    if(status.value.endsWith("_COMPLETED") && destinationId !== undefined) {
      page = `/servicereport/installationDocument/${id}`;
    } else if(status.value.endsWith("_COMPLETED") && destinationId === undefined) {
      page = `/worklist`;
    } else if(!status.value.endsWith("_COMPLETED")) {
      page = `/installationservice/${id}`;
    }

    to = { pathname: page, state: { installationDocumentId: id, installationCode: installationCode, installationDate: updatedAt }};
    return (
      <div className="row vertical-middle text-5 normal-color">
        <Link className='list-item-wrapper' to={linkURL} style={{display: "contents"}}>
          <div className="col-sm-4 text-4 identifier-color">{renderDeviceNames}</div>
          <div className="col-sm-4">
            <div className="row">
              <div className="col-sm-12">{renderShipmentId}</div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="row">
              <div className="col-sm-12">{city}</div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="row">
              <div className="col-sm-12">{postalCode}</div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="row">
              <div className="col-sm-12">{businessCustomer !== null ? businessCustomer.name : ''}</div>
            </div>
          </div>
        </Link>
        <Link className='list-item-wrapper' to={to} style={{display: "contents"}}>
          <h5 className={'identifier-color'} style={{width: '40%', paddingLeft: '54px'}}> { installationShipmentStatus } </h5>
        </Link>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage((state.locale)).code,
  session: state.session,
});

export default connect(
  mapStateToProps,
  null,
)(InstallationDocumentModalItem);



// WEBPACK FOOTER //
// ./src/components/destination/InstallationDocumentModalItem.js